import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import pt from './locales/pt.json';

const i18n = createI18n({
  legacy: true,
  locale: localStorage.getItem('language') || 'pt',
  fallbackLocale: 'pt',
  messages: { en, pt }
});

export default i18n;
